import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Holds the open/closed state of the global help panel.
 *
 * The panel itself lives in the app shell (a split pane next to the routed content); the toolbar
 * help button and the F1 shortcut only flip this flag.
 */
@Injectable({ providedIn: 'root' })
export class HelpService {
  private readonly _isOpen = new BehaviorSubject<boolean>(false);

  /** Whether the help panel is currently shown. */
  readonly isOpen$ = this._isOpen.asObservable();

  get isOpen(): boolean {
    return this._isOpen.value;
  }

  toggle(): void {
    this._isOpen.next(!this._isOpen.value);
  }

  open(): void {
    if (!this._isOpen.value) {
      this._isOpen.next(true);
    }
  }

  close(): void {
    if (this._isOpen.value) {
      this._isOpen.next(false);
    }
  }
}
